// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-locations',
    standalone: false,
    templateUrl: './locations.component.html',
})
export class StatisticsVisitorsLocationsComponent implements OnInit {
    totalVisits: number = 0;
    loading: boolean = false;
    summary: any = {};

    domain: any;
    date: any;
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    exports: any[] = [];
    pages: any[] = [];
    promise: any;
    page: any;
    pageSize: any;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.date = this.dateRangeService.setRangeDates();

        this.updateDateRange();

        this.getPage();

        this.doughnutLabels = [];
        this.doughnutData = [];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
    }

    getPage () {
        const params = {
            limit: 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            from: this.date.startDate?.format('YYYY-MM-DD'),
            to: this.date.endDate?.format('YYYY-MM-DD'),
        };
        this.exports = [
            {
                tooltip: this.translateService.getString('Export visitors locations'),
                name: this.translateService.getString('Visitors locations export'),
                data: {
                    category: 'visitors_locations',
                    category_ref: this.date.startDate?.format('YYYY-MM-DD') + ',' + this.date.endDate?.format('YYYY-MM-DD'),
                },
            },
        ];
        let others = 0;
        this.loading = true;
        this.promise = this.statsRepoService.getLocations(params)
            .then((data: any) => {
                this.pages = data;
                this.totalVisits = data.reduce((total: number, page: any) => {
                    return total + parseInt(page.visits);
                }, 0);
                this.doughnutLabels = [];
                this.doughnutData = [];
                for (let i = 0; i < this.pages.length; i++) {
                    if (i < 5) {
                        this.doughnutLabels.push(this.pages[i].label);
                        this.doughnutData.push(this.pages[i].visits);
                    } else {
                        others += parseInt(this.pages[i].visits);
                    }
                }
                if (this.pages.length > 5) {
                    this.doughnutLabels.push(this.translateService.getString('Others'));
                    this.doughnutData.push(others);
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    pageChange (page: any) {
        this.page = page;
        this.getPage();
    }

    perPageChange (pageSize: any) {
        this.pageSize = pageSize;
        this.getPage();
    }

    updateDateRange () {
        if (this.date.startDate || this.date.endDate) {
            this.paramService.setParams({
                from: moment(this.date.startDate),
                to: moment(this.date.endDate),
            });
            this.getPage();
        }
    }

    average (array: any, prop: string) {
        let sum = 0;
        if (!Array.isArray(array) || array.length === 0) {
            return 0;
        }
        array.forEach((item: any) => {
            sum += parseInt(item[prop]);
        });
        return sum / array.length;
    }

    sum (array: any[], prop: string) {
        if (!Array.isArray(array) || array.length === 0) {
            return 0;
        }
        return array.reduce((total: number, item: any) => total + parseInt(item[prop] || 0), 0);
    }

    getTotalBounceRate () {
        if (!Array.isArray(this.pages) || this.pages.length === 0) {
            return 0;
        }
        const totalBounces = this.pages.reduce((total: number, page: any) => total + parseInt(page.bounce_rate || 0), 0);
        return totalBounces / this.pages.length;
    }

    getActionsPerVisit () {
        if (!Array.isArray(this.pages) || this.pages.length === 0) {
            return 0;
        }
        const totalActions = this.pages.reduce((total: number, page: any) => total + parseInt(page.actions || 0), 0);
        const totalVisits = this.pages.reduce((total: number, page: any) => total + parseInt(page.visits || 0), 0);
        return totalVisits > 0 ? totalActions / totalVisits : 0;
    }

    getAvgTime () {
        if (!Array.isArray(this.pages) || this.pages.length === 0) {
            return 0;
        }
        const totalTime = this.pages.reduce((total: number, page: any) => total + parseInt(page.avg_time || 0), 0);
        return totalTime / this.pages.length;
    }
}
